import { useParams, useNavigate } from "react-router-dom";
import { useBasePath } from '../../../../../util/core/Path';
import React, { useEffect, useState} from "react";

function CustomFormContainer(props) {
    const { id } = useParams();
    let [form, setForm] = useState({});
    const path = useBasePath();
    const navigate = useNavigate();

    const goBack = () => {
        if (form.customGoBackHandler) {
            form.customGoBackHandler()
        } else if(form.urlGoBack && form.urlGoBack != '') {
            navigate(form.urlGoBack);
        } else {
            navigate(-1);
        }
    }

    let defaultPropsForm = {
        showTitle: true,
        labelTitle: id?props.form.labelTitleEdit:props.form.labelTitleAdd,
        content: ''
    }

    if(path == form.pathView){
        defaultPropsForm.labelTitle = props.form.labelTitleView
    }

    useEffect(() => {      
        if(path == props.form.pathView){
            defaultPropsForm.labelTitle = props.form.labelTitleView;
            defaultPropsForm.readOnly = false;
        }
        setForm({...defaultPropsForm,...props.form});

    },[]);

    
    return (
        <div>
        {/* Content Header (Page header) */}
        <section className="content-header">
            <div className="container-fluid">
            <div className="row mb-2">
                <div className="col-sm-6">
                <h1></h1>
                </div>
            </div>
            </div>{/* /.container-fluid */}
        </section>
        {/* Main content */}
        <section className="content">
            <div className="container-fluid">
            <div className="row">
                {/* left column */}
                <div className="col-md-12">
                <div 
                    style={props.containerStyle}
                    className="card card-outline card-info"
                >
                    <div 
                        className="card-header" 
                        style={{
                            borderBottom: form.showTitle ? 'initial' : 'none'
                        }}>
                    {form.showTitle ? 
                        <h3 className="card-title">    
                            <i className="fa-solid fa-pen-to-square mr-1"></i>
                            {form.labelTitle}
                        </h3> : (<></>)}
                        <div style={{float:'right'}}>
                            {form.showGoBackButton && (
                            <button onClick={goBack} type="button" className="btn btn-secondary" style={{ marginRight: '10px' }}>
                                Voltar
                            </button>
                            )}
                        </div>
                    </div>
                    {/* /.card-header */}
                    {/* form start */}
                    {props.content}
                </div>
                {/* /.card */}
                </div>
                {/*/.col (left) */}
                {/* right column */}
                <div className="col-md-6">
                </div>
                {/*/.col (right) */}
            </div>
            {/* /.row */}
            </div>{/* /.container-fluid */}
        </section>
        {/* /.content */}
        </div>
    );
}

export default CustomFormContainer;
